export type TNativeStereoPannerNode = StereoPannerNode;
